module.exports = __webpack_public_path__ + "img/wlh-icon.d14e81bb.png";